import { BaseCustomElement, AjaxSubmit } from "brut-js"

function debounce(operation, wait = 300) {
  let timer = null
  const debounced = function(...args) {
    if (timer) {
      console.log("Clearing un completed operation")
    }
    clearTimeout(timer)
    timer = setTimeout(() => {
      console.log("Operation performed")
      operation.apply(this, args)
    },
    wait)
  }
  debounced.flush = function(...args) {
    clearTimeout(timer)
    timer = null
    return operation.apply(this, args)
  }
  debounced.cancel = function() {
    clearTimeout(timer)
    timer = null
  }
  return debounced
}

class BrowseMealsPage extends BaseCustomElement {
  static tagName = "cc-browse-meals-page"

  static observedAttributes = [
    "show-warnings",
    "results",
    "ready",
    "no-more-results",
  ]

  constructor() {
    super()
  }

  #resultsId = null 
  #state     = null

  resultsChangedCallback({newValue}) {
    this.#resultsId = newValue
  }

  readyChangedCallback() {}
  noMoreResultsChangedCallback() {}

  #okListener = (event) => {
    this.#whenResultsExists( (results) => {
      const replacement = event.detail
      if (!replacement) {
        this.logger.warn("No replacement found in event detail.")
        return
      }
      const tbody = replacement.querySelector("tbody")
      if (tbody) {
        let firstPage = true
        const firstRow = tbody.querySelector("tr")
        if (firstRow) {
          const lastCell = firstRow.querySelector("td:last-child") 
          if (lastCell) {
            if (parseInt(lastCell.textContent) > 0) {
              firstPage = false
            }
          }
          if (firstPage) {
            results.replaceChildren(...tbody.childNodes)
          }
          else {
            results.append(...tbody.childNodes)
          }
          this.removeAttribute("no-more-results")
        }
        else {
          const button = event.target.querySelector("button")
          if (button) {
            if (button.form) {
              const pageInput = button.form.elements["page"]
              if (!pageInput || pageInput.value === "0" || pageInput.value === "") {
                results.innerHTML = ""
              }
            }
            else {
              this.logger.warn("No form found for button in okListener, so cannot use form to figure out if we need to clear results")
            }
          }
          else {
            this.logger.warn("No button found from event in okListener, so cannot use form to figure out if we need to clear results")
          }
          this.setAttribute("no-more-results","")
        }
      }
      else {
        console.log("No tbody found in replacement %o.",replacement)
      }
    })
  }

  #whenResultsExists(callback) {
    if (!this.#resultsId) {
      this.logger.warn("No results ID set, cannot update results.")
      return
    }
    const results = document.getElementById(this.#resultsId)
    if (!results) {
      this.logger.warn(`No results element found with ID '${this.#resultsId}'`)
      return
    }
    callback(results)
  }

  #inflightControllers = new Set()

  #debouncedSubmit = debounce( (searchForm,submitButton) => {
    this.#inflightControllers.forEach( (controller) => {
      console.log("aborting..")
      controller.abort(AjaxSubmit.doNotSubmitThroughBrowser)
    })
    this.#inflightControllers.clear()
    this.querySelectorAll(AjaxSubmit.tagName).forEach( (ajaxSubmit) => {
      const abortController = new AbortController()
      this.#inflightControllers.add(abortController)
      ajaxSubmit.abortSignal = abortController.signal
    })
    searchForm.requestSubmit(submitButton)
  }, 300)

  #searchChanged = (event) => {
    const searchForm = event.target.form
    if (!searchForm) {
      this.logger.warn("Search field has no form, cannot autosubmit.")
      return
    }
    const pageElement = searchForm.elements["page"]
    if (pageElement) {
      pageElement.value = 0
    }
    if (event.target.value.length < 3) {
      this.#debouncedSubmit.cancel()
      return
    }
    this.#submitForm(searchForm)
  }

  #submitForm(searchForm) {
    const submitButton = searchForm.querySelector("button")
    if (!submitButton) {
      this.logger.warn("No submit button found, autosubmit won't work")
      return
    }
    this.#debouncedSubmit(searchForm, submitButton)
  }

  #loadMore = (event) => {
    event.preventDefault()
    const searchForm = event.target.form
    if (!searchForm) {
      this.logger.warn("Search field has no form, cannot autosubmit.")
      return
    }
    const pageElement = searchForm.elements["page"]
    if (pageElement) {
      let value = parseInt(pageElement.value)
      if (isNaN(value)) {
        value = 0
      }
      value = value + 1
      pageElement.value = value
      this.#submitForm(searchForm)
    }
    else {
      this.logger.warn("No page element found in search form, cannot load more.")
    }
  }

  update() {
    this.querySelectorAll(AjaxSubmit.tagName).forEach( (ajaxSubmit) => {
      ajaxSubmit.addEventListener("brut:submitok", this.#okListener)
    })
    const searchField = this.querySelector("input[name='search']")
    if (searchField) {
      searchField.addEventListener("input", this.#searchChanged)
    }
    else {
      this.logger.warn("No search field found, autosubmit won't work")
    }
    const paginationNav = this.querySelector("tfoot nav")
    const loadMoreDiv = this.querySelector("tfoot div:has(button)")
    if (paginationNav && loadMoreDiv) {
      if (this.getAttribute("ready") == null) {
        this.setAttribute("ready","")
      }
      loadMoreDiv.addEventListener("click", this.#loadMore)
    }
    else {
      this.logger.warn("No pagination nav or load more div found, cannot setup load more button.")
    }
    const noMoreResults = this.querySelector("tfoot div[role=status]")
    if (noMoreResults) {
      const contentSpan = noMoreResults.querySelector("span")
      if (contentSpan) {
        if (this.getAttribute("no-more-results") !== null) {
          noMoreResults.innerHTML = `${contentSpan.textContent}${contentSpan.outerHTML}`
        }
        else {
          noMoreResults.innerHTML = `${contentSpan.outerHTML}`
        }
      }
    }
    else {
      this.logger.warn("No no-more-results div[role=status] found, cannot update its content.")
    }
  }
}
export default BrowseMealsPage
